export * from './SalesPotential'
